module.exports = __webpack_public_path__ + "static/media/provider_yggdrasil.87243b49.jpg";